<template>
  <v-main class="primary">
    <transition name="fade" mode="out-in">
      <loader-component v-if="loading"></loader-component>
      <router-view v-else></router-view>
    </transition>
  </v-main>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import LoaderComponent from '../../components/LoaderComponent.vue'
import { MODULOS } from '@/perfiles'

export default {
  components: {
    LoaderComponent,
  },

  async created() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.RECURSOS_HUMANOS)
    await Promise.all([
      this.fetchSedes(),
      this.fetchSubsedes(),
      this.fetchRamasByDependencia(1),
      this.fetchRegiones(),
      this.fetchPuestosByDependencia(1),
      this.fetchAreas(),
      this.fetchSubareas(),
      this.fetchTiposRegion(),
      this.fetchEstatusPersonal(),
      this.fetchEstados(),
      this.fetchMunicipios(),
      this.fetchEstadoCivil(),
      this.fetchTipoNacionalidad(),
      this.fetchSexo(),
      this.fetchGrupoSanguineo(),
    ])
    this.DISABLE_LOADER()
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),
  },

  methods: {
    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('dependencia', ['fetchDependencias']),
    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('subsede', ['fetchSubsedes']),
    ...mapActions('categoria', ['fetchCategorias']),
    ...mapActions('rama', ['fetchRamasByDependencia']),
    ...mapActions('region', ['fetchRegiones']),
    ...mapActions('puesto', ['fetchPuestosByDependencia']),
    ...mapActions('areas', ['fetchAreas']),
    ...mapActions('tipoInstancia', ['fetchTiposInstancia']),
    ...mapActions('tipoRegion', ['fetchTiposRegion']),
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
    ...mapActions('estado', ['fetchEstados']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),
    ...mapActions('subareas', ['fetchSubareas']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('sexo', ['fetchSexo']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
  },
}
</script>
